import ModalManager from 'global/modal/ModalManager';
import AddToCartBackOrder from 'global/addToCart/AddToCartBackOrder';
import { trackAddToCartTaggingData } from 'global/addToCart/addToCartTaggingData';
import { initProductLists } from '../recomendations/initRecommendations';

const addToCartButton = 'data-add-to-cart';

class AddToCartModalManager extends ModalManager {
	showModal() {
		super.showModal();

		if (this.modalHtml.querySelectorAll('#addToCartBackOrderModal').length) {
			return new AddToCartBackOrder(this);
		}

		trackAddToCartTaggingData(this.modalHtml);
		populateCrossSellZones(this.modalHtml);
		return this;
	}
}

const setTaggingData = zone => {
	zone.element.addEventListener('click', e => {
		const button = e.target.closest('BUTTON');
		if (button && button.hasAttribute(addToCartButton)) {
			const navigationMethod = e.currentTarget.getAttribute(
				'data-navigation-method',
			);
			const placementType = e.currentTarget.getAttribute(
				'data-related-product-zone',
			);

			window.od.events.publish('addToCart_Modal', {
				navigationMethod,
				placementType,
			});
		}
	});
};

const populateCrossSellZones = modalHtml => {
	initProductLists(modalHtml, undefined, undefined, true).then(productZones => {
		let hasCrossSell = false;
		if (!productZones && !Array.isArray(productZones)) {
			return;
		}

		productZones.forEach(zone => {
			if (zone.hasProducts()) {
				hasCrossSell = true;
			}

			setTaggingData(zone);
		});

		if (hasCrossSell) {
			duplicateFooter(modalHtml);
		}
	});
};

const duplicateFooter = modalHtml => {
	const topButtons = modalHtml.querySelector(
		'.modal-add-to-cart__continue-buttons',
	);
	const bottomButtons = topButtons.cloneNode(true);
	topButtons.parentElement.appendChild(bottomButtons);
};

export default AddToCartModalManager;
